import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Tab, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import UsersList from "./Tabs/UsersList";
import ApprovalList from "./Tabs/ApprovalList";
import { authActions } from "../../../../redux/actions";
import { translationConstants } from "../../../../constants";

const tab = { user: "userList", approval: "approvals" };

const User = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [key, setKey] = useState("userList");

  useEffect(() => {
    dispatch(authActions.fetchCountries());
    // eslint-disable-next-line
  }, []);

  return (
    <div className="UserDiv">
      <p className="UserTabHeading">{t(translationConstants.user)}</p>
      <div className="tabsDiv">
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className=""
        >
          <Tab eventKey="userList" title={t(translationConstants.UserList)}>
            {key === tab.user && <UsersList />}
          </Tab>
          <Tab eventKey="approvals" title={t(translationConstants.approval)}>
            {key === tab.approval && <ApprovalList />}
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default User;
